import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { onGetDmsList, onGetFullDmsList } from '../../../appRedux/actions/Dms';
import queryString from 'query-string';
import {
  IArchiveFolderList,
  IDmsResponse,
  IDocumentInstanceJsonModel,
} from '../../../interfaces/Dms/Dms';
import { Badge, Button, Col, Drawer, Modal, Row } from 'antd';
import CircularProgress from '../../../components/CircularProgress';
import Widget from '../../../components/Widget';
import { ISettingsReducer } from '../../../interfaces/InitialSettings';
import { onGetDmsTreeMenu } from '../../../appRedux/actions';
import {
  IDataNode,
  ILetterReferTypesStaticsReducer,
} from '../../../interfaces';
import DmsArchiveTreeMenu from '../../../containers/Sidebar/DmsArchiveTreeMenu';
import FetchImage from '../../../components/FetchData/FetchImage';
import CustomScrollbars from '../../../util/CustomScrollbars';
import DmsFolderSearch from './DmsFolderSearch';

export default function DmsArchive() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [expandDrawer, setExpandDrawer] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [openDmsModal, setDmsOpenModal] = useState(false);
  const { locale } = useSelector(
    (settings: { settings: ISettingsReducer }) => settings.settings,
  );

  const dmsArchiveTree = useSelector(
    ({
      letterReferTypesStatics,
    }: {
      letterReferTypesStatics: ILetterReferTypesStaticsReducer;
    }) => {
      return letterReferTypesStatics.dmsArchiveTree;
    },
  ) as IDataNode[];

  const handleOnScrollConatct = () => {
    const parentElement = document.getElementsByClassName(
      'gx-module-content-scroll',
    );
    if (!parentElement || !parentElement[0] || !parentElement[0].children[0])
      return;

    const element = parentElement[0].children[0];
    const scrollTop = (element && element.scrollTop) || document.body.scrollTop;
    const scrollHeight =
      (element && element.scrollHeight) || document.body.scrollHeight;
    const clientHeight = element.clientHeight || window.innerHeight;
    const scrolledToBottom =
      Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (scrolledToBottom) {
      setPageNumber(pageNumber + 1);
    }
  };
  const { folderName, docModel, dmsLoading, archiveFolderList } = useSelector(
    ({ dmsList }: { dmsList: IDmsResponse }) => dmsList,
  );

  useEffect(() => {
    if (pageNumber > 0) {
      const folder = queryString.parse(location.search).folder as string;
      if (folder === 'DmsTrash-0')
        dispatch(onGetDmsList(25, folder, pageNumber + 1, '', true, null));
      else if (folder === 'DmsExpire-0')
        dispatch(onGetDmsList(25, folder, pageNumber + 1, '', false, true));
      else if (folder !== 'dms-0')
        dispatch(onGetDmsList(25, folder, pageNumber + 1, '', false, null));
    }
  }, [pageNumber]);

  useEffect(() => {
    const folder = queryString.parse(location.search).folder as string;
    if (folder === 'DmsTrash-0')
      dispatch(onGetDmsList(25, folder, 0, '', true, null));
    else if (folder === 'DmsExpire-0')
      dispatch(onGetDmsList(25, folder, 0, '', false, true));
    else if (folder !== 'dms-0')
      dispatch(onGetDmsList(25, folder, 0, '', false, null));

    if (dmsArchiveTree.length === 0) dispatch(onGetDmsTreeMenu());
    dispatch(onGetFullDmsList(0, '', '', null));
    window.addEventListener(
      'scroll',
      () => {
        handleOnScrollConatct();
      },
      true,
    );
  }, []);
  useEffect(() => {
    const folder = queryString.parse(location.search).folder as string;
    if (
      folder === 'dms-0' &&
      archiveFolderList &&
      archiveFolderList.length > 0
    ) {
      dispatch(onGetDmsList(25, archiveFolderList[0].code, 0, '', false, null));
    }
  }, [archiveFolderList]);
  const onToggleDrawer = () => {
    setExpandDrawer(!expandDrawer);
  };

  const RenderBageStatusTypeKind = (dmsLetterStatusTypeKind: number) => {
    switch (dmsLetterStatusTypeKind) {
      case 1: {
        return <Badge count={'پیش نویس'} style={{ backgroundColor: 'blue' }} />;
      }
      case 2: {
        return (
          <Badge count={'تایید شده'} style={{ backgroundColor: 'green' }} />
        );
      }
      case 3: {
        return <Badge count={'ابطال شده'} style={{ backgroundColor: 'red' }} />;
      }
      case 5: {
        return (
          <Badge
            count={'ارتباط با نامه '}
            style={{ backgroundColor: 'yellow' }}
          />
        );
      }
      default: {
        return '';
      }
    }
  };
  const SelectedFolder = () => {
    return (
      <Modal
        visible={openDmsModal}
        onCancel={() => setDmsOpenModal(false)}
        onOk={() => setDmsOpenModal(false)}
        title={'انتخاب پوشه'}
        maskClosable={true}
        closable={true}
        footer={false}
      >
        <div>
          <DmsFolderSearch />
          {archiveFolderList &&
            archiveFolderList.length > 0 &&
            archiveFolderList.map((item: IArchiveFolderList, index: number) => {
              return (
                <Widget key={index} styles={{ margin: '0' }}>
                  <Link to={`/team-work/dms?folder=${item.code}`}>
                    نام پرونده:{item?.name} کد :{item.code}
                  </Link>
                </Widget>
              );
            })}
        </div>
      </Modal>
    );
  };
  const DrawerPanelDms = () => {
    return (
      <div className="gx-main-content">
        <div className="gx-app-module">
          <div className="gx-d-block">
            <Drawer
              placement={locale.direction === 'rtl' ? 'right' : 'left'}
              closable={false}
              visible={expandDrawer}
              onClose={onToggleDrawer}
            >
              {' '}
              <Fragment>
                <div className="gx-module-side-header">
                  <div className="gx-module-logo">
                    <i className="icon icon-contacts gx-mx-4" />
                    مدیریت مستندات
                  </div>
                </div>

                <Button
                  onClick={() => {
                    setExpandDrawer(false);
                    setDmsOpenModal(true);
                  }}
                >
                  انتخاب پوشه
                </Button>
                <br />
                <i className={`icon icon-inbox gx-mx-2 `} />
                <span className={'active gx-link icon-menu-down'}>
                  مستندات
                  <div className="gx-module-nav-label gx-py-0 ">
                    <DmsArchiveTreeMenu dmsArchive={dmsArchiveTree} />
                  </div>
                </span>
              </Fragment>
            </Drawer>
          </div>
        </div>
      </div>
    );
  };

  return dmsLoading === true ? (
    <CircularProgress className="" />
  ) : (
    <Fragment>
      <SelectedFolder />
      <DrawerPanelDms />
      <Row className="ant-layout-header">
        <Col md={4} xs={4} sm={4}>
          <div className="gx-d-flex gx-flex-row gx-justify-content-left gx-align-items-center">
            <div className=" gx-px-1 gx-w-100 gx-mb-2">
              <i
                style={{
                  fontSize: 'x-large',
                  textAlign: 'center',
                  height: 25,
                }}
                className="icon icon-menu gx-mx-3"
                aria-label="Menu"
                onClick={onToggleDrawer}
              />
            </div>
          </div>
        </Col>
        <Col md={20} xs={20} sm={20}>
          {folderName}
        </Col>
      </Row>
      <CustomScrollbars className="gx-module-content-scroll">
        <Row>
          {docModel &&
            docModel.length > 0 &&
            docModel.map((item: IDocumentInstanceJsonModel, index: number) => {
              return (
                <Col md={6} xs={24} sm={24} key={index}>
                  <Widget title={''}>
                    <Link
                      to={`/team-work/instance-details?letterCode=${
                        item.letterCode
                      }&foder=${
                        item.letterNumber === null ? 'Draft-0' : 'Inbox-0'
                      }&isDraft=${item.letterNumber === null}`}
                    >
                      <Row>
                        <Col md={24} xs={24} sm={24}>
                          <p className="active gx-link">{item.subject}</p>
                        </Col>
                        <Col md={24} xs={24} sm={24}>
                          {item.letterNumber === null ? (
                            <p>[پیش نویس]</p>
                          ) : (
                            <p>{item.letterNumber}</p>
                          )}
                        </Col>
                        <Col md={6} xs={6} sm={6}>
                          <FetchImage
                            src={`contactPicture/getContactPicture?id=${
                              item.employeeIdCreator
                            }&height=${40}&width=${40}`}
                            className="ant-avatar-lg"
                            alt="ایجاد کننده"
                          />
                        </Col>
                        <Col md={18} xs={18} sm={18}>
                          <Row>
                            <Col md={24} xs={24} sm={24}>
                              ایجاد کننده: {item.creatorFullName}
                            </Col>
                            <Col md={24} xs={24} sm={24}>
                              تاریخ ثبت :{item.letterDate}
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12} xs={12} sm={12}>
                          {RenderBageStatusTypeKind(
                            item.dmsLetterStatusTypeKind,
                          )}
                        </Col>
                        <Col md={12} xs={12} sm={12}>
                          تعدادفایل: {item.fileCount}
                        </Col>
                      </Row>
                    </Link>
                  </Widget>
                </Col>
              );
            })}
        </Row>
      </CustomScrollbars>
    </Fragment>
  );
}
